(function (root, factory) {
  const createPageTrackingSession = factory();

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = createPageTrackingSession;
    return;
  }

  if (root) {
    root.createPageTrackingSession = createPageTrackingSession;
  }
})(typeof window !== 'undefined' ? window : undefined, function createPageTrackingSessionFactory() {
  return function createPageTrackingSession(core) {
    const state = core.state;

    function trackSessionStart(isNewSession, isNewUser) {
      const now = new Date();
      const dataInfo = core.buildDataInfo({
        type: core.config.eventTypes && core.config.eventTypes.sessionStart,
        isNewSession: Boolean(isNewSession),
        isNewUser: Boolean(isNewUser)
      }, now);

      return core.sendTrackingEvent({
        basicInfo: core.buildBasicInfo(),
        dataInfo: dataInfo
      }, true);
    }

    function startNewSession(nowMs, isNewUser, callbacks) {
      const currentCallbacks = callbacks || {};

      core.writeSessionStorage(core.sessionIdKey, core.createSessionId());
      core.writeSessionStorage(core.sessionStartAtKey, String(nowMs));
      core.clearEndedSessionId();

      if (typeof currentCallbacks.resetPageSessionState === 'function') {
        currentCallbacks.resetPageSessionState();
      }

      core.markActivity(nowMs);
      trackSessionStart(true, isNewUser);

      if (typeof currentCallbacks.scheduleInitialPageViewExposure === 'function') {
        currentCallbacks.scheduleInitialPageViewExposure();
      }
    }

    function ensureActiveSession(nowMs, callbacks) {
      const interactionTimeMs = nowMs || Date.now();
      const trackingUser = core.resolveTrackingUser();

      if (core.shouldStartNewSession(interactionTimeMs)) {
        startNewSession(interactionTimeMs, trackingUser.isNewUser, callbacks);
        return true;
      }

      return false;
    }

    function initializeSession(callbacks) {
      const currentCallbacks = callbacks || {};
      const nowMs = Date.now();
      const isNewSession = core.shouldStartNewSession(nowMs);
      const trackingUser = core.resolveTrackingUser();

      if (isNewSession) {
        startNewSession(nowMs, trackingUser.isNewUser, currentCallbacks);
        return;
      } else if (!core.getSessionStartAt()) {
        core.writeSessionStorage(core.sessionStartAtKey, String(nowMs));
        core.markActivity(nowMs);

        if (typeof currentCallbacks.syncInitialScrollDepth === 'function') {
          currentCallbacks.syncInitialScrollDepth();
        }

        return;
      }

      core.markActivity(nowMs);

      if (typeof currentCallbacks.syncInitialScrollDepth === 'function') {
        currentCallbacks.syncInitialScrollDepth();
      }
    }

    return {
      trackSessionStart,
      startNewSession,
      ensureActiveSession,
      initializeSession
    };
  };
});
